import { jsx as p } from "react/jsx-runtime";
import * as m from "react";
import { R as f } from "../index-B_nZygZa.js";
const i = "_separator_1b242_1", o = {
  separator: i
}, n = m.forwardRef(
  ({ className: r, orientation: a = "horizontal", decorative: t = !0, ...e }, s) => /* @__PURE__ */ p(
    f,
    {
      ref: s,
      orientation: a,
      decorative: t,
      className: r ? `${o.separator} ${r}` : o.separator,
      ...e
    }
  )
);
n.displayName = "Separator";
export {
  n as Separator
};
